import {ADD_ACTIVITIES, ADD_ACTIVITY, CLEAR_ACTIVITIES, REMOVE_ACTIVITY, SET_ACTIVITY_VIEW, SET_ACTIVITY_QUERY} from "../actionTypes";
import { defineState } from 'redux-localstore';


const defaultActivityState = {
  collectorActivities: [],
  activityView: 0,
  activityQuery: ""
};

const initialActivitiesState = defineState(defaultActivityState)('collectorActivities');


export function activityReducers (state = initialActivitiesState, action) {
  switch (action.type) {
    case ADD_ACTIVITY:
      if (!state.collectorActivities.includes(action.payload)) {
        return {
          ...state,
          collectorActivities: state.collectorActivities.concat([action.payload].filter(({id}) => !state.collectorActivities.find(f => f.id === id) )),
        };
      } else {
        return state;
      }
    case ADD_ACTIVITIES:
      return {
        ...state,
        collectorActivities: state.collectorActivities.concat(action.payload.filter(({id}) => !state.collectorActivities.find(f => f.id === id) )),
      };
    case CLEAR_ACTIVITIES:
      return {
        ...state,
        collectorActivities: []
      };
    case REMOVE_ACTIVITY:
      return {
        ...state,
        collectorActivities: state.collectorActivities.filter( a => a.id !== action.payload.id )
      };
    case SET_ACTIVITY_VIEW:
      return {
        ...state,
        activityView: action.payload
      };
    case SET_ACTIVITY_QUERY:
      return {
        ...state,
        activityQuery: action.payload
      };
    default:
      return state
  }
}
